import React from 'react';
import propTypes from 'prop-types';

const DonationLanguage = ({ partsFlag, donationLanguage, getAttribute }) => {
	return (
		<>
			<div className="d-flex flex-column align-items-center mx-md-15 mx-6 mt-6">
				<h1 className="text-headline text-center mb-6">
					{getAttribute.text(4)}
				</h1>
				<p className="text-center px-md-12 mb-6">
					{getAttribute.text(5)}
				</p>
			</div>
			<div
				id={partsFlag === 'Y' ? 'stlservice' : null}
				className="row mx-md-15 mx-6"
			>
				<div className="col-md-12 text-subhead-bold text-center px-md-12 mb-6">
					<p>{donationLanguage}</p>
				</div>
			</div>
		</>
	);
};

DonationLanguage.propTypes = {
	donationLanguage: propTypes.string,
	partsFlag: propTypes.string,
	getAttribute: propTypes.shape({
		text: propTypes.func,
		path: propTypes.func
	})
};

export default DonationLanguage;
